import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { LayoutPlugin, TablePlugin, FormCheckboxPlugin } from 'bootstrap-vue';
// import { setInteractionMode } from 'vee-validate';
import VueSimplebar from 'vue-simplebar';
import 'vue-simplebar/dist/vue-simplebar.min.css';
import vueDebounce from 'vue-debounce';

// use plugins
Vue.use(VueAwesomeSwiper);
Vue.use(LayoutPlugin, { breakpoints: ['xs', 'sm', 'md', 'lg', 'xl'] });
Vue.use(TablePlugin);
Vue.use(FormCheckboxPlugin);
// setInteractionMode('lazy');
Vue.use(VueSimplebar);
Vue.use(vueDebounce);
